class FAQAccordion {
  static instances = [];

  constructor(domNode) {
    this.rootEl = domNode;
    this.buttonEl = this.rootEl.querySelector('button[aria-expanded]');
    const controlsId = this.buttonEl.getAttribute('aria-controls');
    this.contentEl = document.getElementById(controlsId);
    this.isOpen = this.buttonEl.getAttribute('aria-expanded') === 'true';
    FAQAccordion.instances.push(this);
    this.buttonEl.addEventListener('click', this.onButtonClick.bind(this));
  }

    onButtonClick() {
     const isOpen =
     this.buttonEl.getAttribute('aria-expanded') === 'true';

      if (isOpen) {
        this.close();
      } else {
        FAQAccordion.instances.forEach((accordion) => {
          if (accordion !== this) {
            accordion.close();
          }
        });

        this.open();
      }
  }

  open() {
    this.contentEl.hidden = false;
    this.contentEl.style.height = '0px';


    requestAnimationFrame(() => {
      this.contentEl.style.height =
        `${this.contentEl.scrollHeight}px`;
    });

    this.buttonEl.setAttribute('aria-expanded', 'true');
    this.isOpen = true;

    this.contentEl.addEventListener(
      'transitionend',
      () => {
        if (this.isOpen) {
          this.contentEl.style.height = 'auto';
        }
      },
      { once: true }
    );
  }

  close() {
    this.contentEl.style.height =
      `${this.contentEl.scrollHeight}px`;

    requestAnimationFrame(() => {
      this.contentEl.style.height = '0px';
    });

    this.buttonEl.setAttribute('aria-expanded', 'false');
    this.isOpen = false;

    this.contentEl.addEventListener(
      'transitionend',
      () => {
        if (!this.isOpen) {
          this.contentEl.hidden = true;
        }
      },
      { once: true }
    );
  }
}

// init accordions
document.querySelectorAll('.faq-accordion h3').forEach((accordionEl) => {
  new FAQAccordion(accordionEl);
});
